import React from 'react';
import Dropzone from 'react-dropzone';
import axios from 'axios';
import { Alert, FormFeedback } from 'reactstrap';

import Aux from '../../containers/Aux';
import SortableList from './SortList';
import UnsortableItem from './UnsortableItem';
import { arrayMove } from 'react-sortable-hoc';

import Http from '../../utils/Http';

import {
    cloudinaryApiKey,
    prodCloudinaryApiKey,
    cloudinaryApiUploadPreset,
    prodCloudinaryApiUploadPreset,
    EAGER,
} from '../../../config/config';

import './fileUpload.css';

class FileUpload extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            files: [],
            imageStore: [],
            uploadError: false,
            isDisabled: true,
            fileTypes: '',
            uploadProgress: 0,
        };

        this.handleDrop = this.handleDrop.bind(this);
        this.remove = this.remove.bind(this);
        this.isDisabled = this.isDisabled.bind(this);
        this.checkAllowedFileTypes = this.checkAllowedFileTypes.bind(this);
    }

    componentDidMount() {
        // Set the state to any files saved to the parent input
        this.setState({
            files: this.props.input.value ? this.props.input.value : [],
        });
        this.isDisabled();
        this.checkAllowedFileTypes();
    }

    handleDrop = (files) => {
        // Create a temp store of images for processing
        this.setState({
            imageStore: files,
        });

        console.log(files);

        let newUploadedFiles = [...this.props.input.value];

        const uploaders = files.map((file, index) => {
            const config = {
                onUploadProgress: (progressEvent) => {
                    let percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total)
                    this.setState({ uploadProgress: percentCompleted })
                }
            }
            console.log(file, 'dsf');
            const formData = new FormData();
            formData.append('file', file);
            formData.append('tags', '');
            formData.append('upload_preset', cloudinaryApiUploadPreset); // Replace the preset name
            formData.append('api_key', cloudinaryApiKey); // Replace API key with Cloudinary key
            formData.append('timestamp', (Date.now() / 1000) | 0);
            formData.append('resource_type', 'auto');
            // formData.append('type', 'private');
            // formData.append("eager", EAGER);

            return Http.post(
                `file-upload/${(file.type === 'text/csv' || file.type === 'application/vnd.ms-excel' || this.props.csv) ? 'csv' : 'image'}`,
                formData, config
            )
                .then((response) => {
                    const data = response.data;

                    newUploadedFiles.push(data);
                    // this.setState({
                    //   files: uploaded
                    // });
                    // this.props.input.onChange(uploaded);
                    window.URL.revokeObjectURL(file.preview);
                    file = Object.assign({}, file, {
                        isLoading: false,
                    });
                })
                .catch((err) => {
                    console.log(err);
                    this.setState({
                        uploadError: true,
                        errorMsg: err.response.data.message,
                    });
                    file = Object.assign({}, file, {
                        isLoading: false,
                    });
                });
        });

        axios.all(uploaders).then(() => {
            this.setState({
                imageStore: [],
                files: newUploadedFiles,
            });
            this.props.input.onChange(newUploadedFiles);
        });
    };

    remove = (index) => {
        const array = this.state.files;
        const confirm = window.confirm(
            'Are you sure you want to remove this image?'
        );
        if (confirm) {
            array.splice(index, 1);
            this.setState({ files: array });
            this.props.input.onChange(array);
        }
    };

    onSortEnd = ({ oldIndex, newIndex }) => {
        const filesToMove = [...this.state.files];
        const filesIn = arrayMove(filesToMove, oldIndex, newIndex);
        this.setState({
            files: filesIn,
        });
        this.props.input.onChange(this.state.files);
    };

    isDisabled = () => {
        if (!this.props.multiple) {
            this.setState({
                isDisabled: true,
            });
        } else {
            this.setState({
                isDisabled: false,
            });
        }
    };

    checkAllowedFileTypes() {
        const canAcceptFiles = this.props.files;
        const canAcceptImages = this.props.images;
        const imageTypes = 'image/jpg, image/jpeg, image/png';
        const fileTypes = '.pdf, .csv';

        if (canAcceptFiles && !canAcceptImages) {
            this.setState({
                fileTypes: fileTypes,
            });
        }
        if (!canAcceptFiles && canAcceptImages) {
            this.setState({
                fileTypes: imageTypes,
            });
        }
        if (canAcceptFiles && canAcceptImages) {
            var combinedTypes = imageTypes + ',' + fileTypes;
            this.setState({
                fileTypes: combinedTypes,
            });
        }
    }

    render() {
        const temp = this.state.imageStore;

        return (
            <Aux>
                {this.state.uploadProgress > 0 && this.state.uploadProgress < 100 && <div style={{ width: `${this.state.uploadProgress}%` }} className='file-progress-bar'></div>}
                <Dropzone
                    multiple={this.props.multiple}
                    onDrop={this.handleDrop}
                    className='dropzone'
                    disabled={this.state.disabled}
                    name={this.props.input.name}
                    accept={this.state.fileTypes}
                >
                    <p>Drop an image or click to select a file to upload.</p>
                </Dropzone>

                {this.state.uploadError ? (
                    <Alert color='danger'>
                        There was an error uploading your file. Please try
                        again.
                    </Alert>
                ) : null}

                {this.props.meta.touched && this.props.meta.error && (
                    <FormFeedback style={{ display: 'block' }}>
                        {this.props.meta.error}
                    </FormFeedback>
                )}

                <SortableList
                    items={this.state.files}
                    onSortEnd={this.onSortEnd}
                    removeItem={this.remove}
                    pressDelay={100}
                    axis='xy'
                    hasProgress={false}
                    helperClass='dragging'
                    hideSortableGhost={true}
                    lockToContainerEdges={true}
                />

                <div className='temp-store'>
                    {temp.map((file, index) => (
                        <UnsortableItem
                            key={`item-${index}`}
                            index={index}
                            value={file}
                            sortIndex={index}
                            hasProgress={true}
                        />
                    ))}
                </div>
            </Aux>
        );
    }
}

export default FileUpload;



// WEBPACK FOOTER //
// ./src/system/fields/FileUpload/index.jsx